import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import memberSlice from './member/memberSlice'
import wjpediaSlice from './wjpedia/wjpediaSlice'
import wjpediaDetailSlice from './wjpediaDetail/wjpediaDetailSlice'
import modernSlice from './modern/modernSlice'

const persistConfig = {
  key: 'modern',
  storage,
  whitelist: ['member', 'wjpedia','wjpediaDetail', 'modern']
}

const rootReducer = combineReducers({
  member: memberSlice,
  wjpedia: wjpediaSlice,
  wjpediaDetail: wjpediaDetailSlice,
  modern: modernSlice
})

export type RootState = ReturnType<typeof rootReducer>

export default persistReducer(persistConfig ,rootReducer)
